// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f63c73eb","453":"91b58b3a","950":"fc6b8f5a","987":"c90e4c09"}[chunkId] + ".chunk.js";
};